// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WSGg0","fullView":"styles_fullView__qjOno"};